import React from 'react';
import { Mic2, Twitter, Github, Linkedin, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#050508] border-t border-white/10 pt-16 pb-8" data-id="element-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-22">
          {/* Brand */}
          <div data-id="element-23">
            <div className="flex items-center gap-2 mb-6" data-id="element-24">
              <div className="w-8 h-8 bg-[#00F0FF] rounded flex items-center justify-center text-black" data-id="element-25">
                <Mic2 size={20} data-id="element-26" />
              </div>
              <span className="text-xl font-bold font-mono tracking-tighter text-white" data-id="element-27">
                ECHEC<span className="text-[#00F0FF]" data-id="element-28">GAMER</span>
              </span>
            </div>
            <p className="text-gray-500 text-sm mb-6" data-id="element-29">
              Synthesizing the future of voice with advanced AI technology. Made
              with <span className="text-[#FF00AA]" data-id="element-30">♥</span> in Poland.
            </p>
            <div className="flex gap-4" data-id="element-31">
              <a href="#" className="text-gray-500 hover:text-white transition-colors" data-id="element-32">
                <Twitter size={20} data-id="element-33" />
              </a>
              <a href="#" className="text-gray-500 hover:text-white transition-colors" data-id="element-34">
                <Github size={20} data-id="element-35" />
              </a>
              <a href="#" className="text-gray-500 hover:text-white transition-colors" data-id="element-36">
                <Linkedin size={20} data-id="element-37" />
              </a>
              <a href="#" className="text-gray-500 hover:text-white transition-colors" data-id="element-38">
                <Instagram size={20} data-id="element-39" />
              </a>
            </div>
          </div>

          {/* Product */}
          <div data-id="element-40">
            <h4 className="text-white font-mono font-bold mb-6" data-id="element-41">Product</h4>
            <ul className="space-y-4 text-sm text-gray-500" data-id="element-42">
              <li data-id="element-43">
                <a href="#" className="hover:text-[#00F0FF] transition-colors" data-id="element-44">
                  Harmonic Forge
                </a>
              </li>
              <li data-id="element-45">
                <a href="#" className="hover:text-[#00F0FF] transition-colors" data-id="element-46">
                  Voice Library
                </a>
              </li>
              <li data-id="element-47">
                <a href="#" className="hover:text-[#00F0FF] transition-colors" data-id="element-48">
                  API Documentation
                </a>
              </li>
              <li data-id="element-49">
                <a href="#" className="hover:text-[#00F0FF] transition-colors" data-id="element-50">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-51">
            <h4 className="text-white font-mono font-bold mb-6" data-id="element-52">Resources</h4>
            <ul className="space-y-4 text-sm text-gray-500" data-id="element-53">
              <li data-id="element-54">
                <a href="#" className="hover:text-[#00F0FF] transition-colors" data-id="element-55">
                  Community
                </a>
              </li>
              <li data-id="element-56">
                <a href="#" className="hover:text-[#00F0FF] transition-colors" data-id="element-57">
                  Help Center
                </a>
              </li>
              <li data-id="element-58">
                <a href="#" className="hover:text-[#00F0FF] transition-colors" data-id="element-59">
                  Blog
                </a>
              </li>
              <li data-id="element-60">
                <a href="#" className="hover:text-[#00F0FF] transition-colors" data-id="element-61">
                  Status
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-62">
            <h4 className="text-white font-mono font-bold mb-6" data-id="element-63">Contact</h4>
            <address className="not-italic text-sm text-gray-500 space-y-4" data-id="element-64">
              <p data-id="element-65">Echecgamer Sp. z o.o.</p>
              <p data-id="element-66">ul. Marszałkowska 126</p>
              <p data-id="element-67">00-008 Warszawa, Poland</p>
              <p className="pt-2 text-[#00F0FF]" data-id="element-68">hello@echecgamer.com</p>
            </address>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-69">
          <p className="text-gray-600 text-sm" data-id="element-70">
            © 2026 Echecgamer. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-600" data-id="element-71">
            <a href="#" className="hover:text-white" data-id="element-72">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white" data-id="element-73">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}